import React from "react";
import { Field, ErrorMessage } from "formik";

export default function VerificationDetailsComponent({ formik }) {
  return (
    <div
      className="col-12 my-0 rounded-3 border-vcg-muted p-4"
      style={{ backgroundColor: "#fff" }}
    >
      <h4 className="fw-bold mb-4">Verification Details</h4>
      <div className="alert alert-info">
        <p className="mb-1">
          You are required to provide <strong>one of the following</strong> to
          verify that you were a student of the college:
        </p>
        <ul className="mb-0">
          <li>A School Leaving Certificate (Recommended)</li>
          <li>A formal Proof Document</li>
          <li>Your School Admission or Enrollment Number</li>
        </ul>
      </div>

      {/* Proof Document */}
      <div className="col-12 mb-3">
        <label className="form-label">
          Leaving Certificate / Proof Document
        </label>
        <input
          type="file"
          className="form-control"
          accept="image/*,application/pdf"
          onChange={(e) => {
            formik.setFieldValue("proofDocument", e.currentTarget.files[0]);
          }}
        />
        {formik.values.proofDocument && (
          <small className="text-success">
            {formik.values.proofDocument.name}
          </small>
        )}
        <ErrorMessage
          name="proofDocument"
          component="div"
          className="text-danger"
        />
      </div>

      {/* School Enrollment Number */}
      <div className="col-12 mb-3">
        <label className="form-label">
          School Admission / Enrollment Number
        </label>
        <Field type="text" className="form-control" name="enrollmentNumber" />
        <ErrorMessage
          name="enrollmentNumber"
          component="div"
          className="text-danger"
        />
      </div>
    </div>
  );
}
